import { HTMLAttributeAnchorTarget } from 'react';
import { Link } from 'react-router-dom';
import { CSSProperties } from 'styled-components';

type Props = {
  uri: any;
  identificador: string | number;
  style?: CSSProperties;
  target?: HTMLAttributeAnchorTarget;
  sistema?: string;
};

const CustomLink = ({
  identificador,
  uri,
  style,
  target = '_blank',
  sistema = undefined
}: Props) => {
  const children = (
    <>
      {identificador}&nbsp;&nbsp;
      <i className="fas fa-external-link-alt blue-40" />
    </>
  );

  const rel = 'noopener noreferrer';

  if (sistema) {
    return (
      <a
        href={`/${sistema}/${uri.replace(/^\//, '')}`}
        target={target}
        rel={rel}
        style={style}
      >
        {children}
      </a>
    );
  }
  return (
    <Link target={target} rel={rel} to={uri} style={style}>
      {children}
    </Link>
  );
};

export { CustomLink };
